export default {
  title: 'Bienvenido',
  subtitle: 'Inicia sesión para gestionar tu cuenta y pedidos',
  benefits: {
    earn_points: {
      title: 'Gana puntos con cada pedido',
      description: 'Acumula puntos y desbloquea recompensas exclusivas',
    },
    get_deals: {
      title: 'Recibe descuentos exclusivos',
      description: 'Usa tus puntos para obtener artículos gratis',
    },
    redeem_points: {
      title: 'Canjea puntos por comida gratis',
      description: 'Accede a promociones exclusivas para miembros',
    },
  },
};
